import styled from "styled-components";
import { ButtonSettings, Icon, Heading } from "../../../services/visualLibraryService";

export const ThankYouPageStyled = styled.section`
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  padding: ${props => props.theme.baseLayoutPaddingBs * 2}% ${props => props.theme.baseLayoutPaddingBs * 3}%;
  background: ${props => props.background && `url(${props.background}) 0 0 / cover no-repeat`};
`;

export const ThankYouContainerStyled = styled.article`
  margin: auto;
  text-align: center;
`;

export const IconStyled = styled(Icon)`
  width: 4vw;
  height: 4vw;
  margin-bottom: ${props => props.theme.spacing.xsmall};
  fill: ${props => props.theme.color.primary};
`;

export const HeadingStyled = styled(Heading)`
  &&& {
    font-weight: ${props => props.theme.font.weight.light};
    line-height: ${props => props.theme.font.lineHeight.medium};
  }
`;

export const ButtonModalStyled = styled(ButtonSettings)`
  text-transform: uppercase;
  width: 35rem;
  &&& {
    margin: ${props => props.theme.spacing.large} ${props => props.theme.spacing.xsmall};
  }
`;
